/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { Employee } from "types";

type Response = {
  payload: Employee[];
};

export function useEmployeeList() {
  const api = useApi();
  const [data, setData] = useState<Employee[]>([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api
      .get("employee/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? [];
        setData(data);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, []);

  return {
    data,
    isLoading,
    refetch,
    dropdown: data.map((item) => ({
      label: `${item.employee_name}`,
      value: item.employee_id.toString()
    }))
  };
}
